export const SEARCH_LOCATIONS = "SEARCH_LOCATIONS";
export const NEW_LOCATION = "NEW_LOCATION";
export const GET_LOCATION_BY_ID = "GET_LOCATION_BY_ID";
export const UPDATE_LOCATION = "UPDATE_LOCATION";
